import * as React from "react";
const VisitorsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <mask
      id="aVisitorsIcon"
      width={20}
      height={21}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 .5h20v20H0z" />
    </mask>
    <g mask="url(#aVisitorsIcon)">
      <path
        fill={props.fill}
        d="M.833 17.167v-2.334c0-.472.122-.906.365-1.302a2.43 2.43 0 0 1 .968-.906 12.37 12.37 0 0 1 2.625-.969 11.464 11.464 0 0 1 2.709-.323c.916 0 1.82.108 2.708.323a12.37 12.37 0 0 1 2.625.969c.403.208.726.51.969.906s.364.83.364 1.302v2.334H.833Zm15 0v-2.5c0-.611-.17-1.198-.51-1.76-.34-.563-.823-1.046-1.448-1.449a10.435 10.435 0 0 1 3.75 1.167c.5.278.882.587 1.145.927.264.34.396.712.396 1.115v2.5h-3.333ZM7.5 10.5a3.21 3.21 0 0 1-2.354-.98 3.21 3.21 0 0 1-.98-2.353c0-.917.327-1.702.98-2.355A3.21 3.21 0 0 1 7.5 3.833a3.21 3.21 0 0 1 2.354.98 3.21 3.21 0 0 1 .979 2.354 3.21 3.21 0 0 1-.98 2.354A3.21 3.21 0 0 1 7.5 10.5Zm8.333-3.333a3.21 3.21 0 0 1-.98 2.354 3.21 3.21 0 0 1-2.353.979c-.153 0-.348-.017-.584-.052a5.114 5.114 0 0 1-.583-.115c.375-.444.663-.937.865-1.479a4.804 4.804 0 0 0 .302-1.687c0-.584-.101-1.146-.302-1.688A4.956 4.956 0 0 0 11.333 4c.194-.069.389-.114.583-.135.195-.02.39-.03.584-.03a3.21 3.21 0 0 1 2.354.978 3.21 3.21 0 0 1 .979 2.355ZM2.5 15.5h10v-.667a.812.812 0 0 0-.417-.708 10.862 10.862 0 0 0-2.27-.844 9.667 9.667 0 0 0-4.626 0c-.764.188-1.52.469-2.27.844a.811.811 0 0 0-.417.708v.667Zm5-6.667c.458 0 .85-.163 1.177-.49.326-.326.49-.718.49-1.176 0-.459-.164-.851-.49-1.178A1.605 1.605 0 0 0 7.5 5.5c-.459 0-.851.164-1.177.49-.327.327-.49.72-.49 1.178 0 .458.163.85.49 1.177.326.326.718.49 1.177.49Z"
      />
    </g>
  </svg>
);
export default VisitorsIcon;
